module.exports = __webpack_public_path__ + "img/app-bg-top.f71b2775.png";